import { CountryCode, geoCountryCodes } from 'corso-types';

const prioritized: CountryCode[] = [CountryCode.US, CountryCode.CA];
const countryCodes = Object.values(CountryCode);

const prioritizedOptions = prioritized
  .filter((code) => countryCodes.includes(code))
  .map((code) => ({
    label: geoCountryCodes[code].name,
    value: code,
  }));

export const countryCodeOptions = [
  ...prioritizedOptions,
  ...countryCodes
    .filter((code) => !prioritized.includes(code))
    .map((code) => ({
      label: geoCountryCodes[code].name,
      value: code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)),
];
